import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Invalid() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // エラーメッセージを取得（デフォルトは「本URLは無効です。」）
  const errorMessage = location.state?.errorMessage || '本URLは無効です。';
  
  // トップページに戻る
  const handleGoToTop = () => {
    navigate('/');
  };

  return (
    <React.Fragment>
      <Grid container direction="column" spacing={2} style={{ padding: '16px' }}>
        {/* 1. タイトル */}
        <Grid item xs={12}>
          <Typography variant="h5" style={{ marginBottom: '16px', fontWeight: 'bold' }}>
            表示エラー
          </Typography>
        </Grid>
        
        {/* 2. 画面概要（エラーメッセージ） */}
        <Grid item xs={12}>
          <Paper 
            elevation={0} 
            style={{ 
              backgroundColor: '#FFEEEE', 
              padding: '24px', 
              marginBottom: '32px',
              minHeight: '100px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center'
            }}
          >
            <Typography variant="body1" style={{ color: '#D32F2F', fontSize: '18px' }}>
              {errorMessage}
            </Typography>
          </Paper>
        </Grid>
        
        {/* トップページに戻るボタン */}
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            style={{ 
              padding: '12px 32px',
              fontSize: '16px'
            }}
            onClick={handleGoToTop}
          >
            トップページに戻る
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
